/*
 *
 * ExtendSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import { connect } from 'react-redux'
import { doExtendSession } from 'Store/actions/login'
import { doHidePopup } from 'Store/actions/popup'
import ExtendSessionModal from './ExtendSessionModal'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  extendSession: () => dispatch(doExtendSession()),
  hidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading.extend_session, false),
  sessionType: nullSafe(() => state.popup.popupInfo.sessionType, 'PORTAL')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ExtendSessionModal)
